import './SFNT.scss';
import { PageManager } from '@mvps-genesis/core';

export default class SFNT extends PageManager {

	constructor( pageContext ) {

		super( pageContext );

	}

	onReady() {

		const self = this;

	}

}
